import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FirebaseService } from './services/firebase.service';
import { first } from 'rxjs/operators';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image-more';
import { jsPDF } from 'jspdf';
import domToImage from 'dom-to-image-improved';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  respuestas = Array(75);
  respuestasDim = Array();
  promediosDim = Array();
  promediosDom = Array(5);
  radarDim = Array();
  radarDom = Array();
  arrFlexibilidad = Array();
  arrAdaptabilidad = Array();
  arrConocimiento = Array();
  arrAgilidad = Array();
  arrDigital = Array();
  imgcultura1: string;
  imgcultura2: string;
  imgcultura3: string;
  imgliderazgo: string;
  imgestretegia: string;
  imgasignacion: string;
  imggerencia: string;
  imgclientes: string;
  imgorganigrama: string;
  imgtalentos: string;
  imgproductivo: string;
  imgexperimentacion: string;
  imginternos: string;
  imgejecucion: string;
  imgcompetencia: string;
  imgtendencia: string;
  imgdeterminacion1: string;
  imgdeterminacion2: string;
  imgdeterminacion3: string;
  imagenModelo: any;
  liderazgo;
  gerencia;
  experimentacion;
  internos;
  productivo;
  ejecucion;
  competencia;
  tendencia;
  organigrama;
  clientes;
  determinacion;
  asignacion;
  estrategias;
  talentos;
  cultura;
  mtzRadarDominio;
  mtzRadarDimension;
  widthImage;
  heigthImage;

  constructor(
    public router: Router,
    public db: FirebaseService,
    private afAuth: AngularFireAuth,
  ) {}

  ngOnInit() {
    this.afAuth.authState.pipe(first()).subscribe((user) => {
      if (!user) {
        this.afAuth.signInAnonymously().catch((err) => {
          console.error('Error en signInAnonymously:', err);
        });
      }
    });
  }

  respuestasDimsension(arr, index) {
    this.respuestasDim[index] = arr;
  }

  promedioDimension(arr, index) {
    const reducer = (prev, curr) => prev + curr;
    let promedioDim = arr.reduce(reducer) / 5;
    this.promediosDim[index] = promedioDim.toFixed(2);
    if (!sessionStorage.getItem('promDim')) {
      sessionStorage.setItem('promDim', JSON.stringify(this.promediosDim));
    } else {
      let promediosDim = JSON.parse(sessionStorage.getItem('promDim'));
      promediosDim[index] = promedioDim.toFixed(2);
      sessionStorage.setItem('promDim', JSON.stringify(this.promediosDim));
    }
    //LLenar arreglos para realizar promedio de Dominios
    if (this.promediosDim.length === 15) {
      this.arrFlexibilidad = this.promediosDim.slice(0, 3);
      this.arrAdaptabilidad = this.promediosDim.slice(3, 6);
      this.arrConocimiento = this.promediosDim.slice(6, 9);
      this.arrAgilidad = this.promediosDim.slice(9, 12);
      this.arrDigital = this.promediosDim.slice(12, 15);
      for (let i = 0; i < 3; i++) {
        this.arrFlexibilidad[i] = parseFloat(this.arrFlexibilidad[i]);
        this.arrAdaptabilidad[i] = parseFloat(this.arrAdaptabilidad[i]);
        this.arrConocimiento[i] = parseFloat(this.arrConocimiento[i]);
        this.arrAgilidad[i] = parseFloat(this.arrAgilidad[i]);
        this.arrDigital[i] = parseFloat(this.arrDigital[i]);
      }
      let promedioFlexibilidad = this.arrFlexibilidad.reduce(reducer) / 3;
      this.promediosDom[0] = promedioFlexibilidad.toFixed(2);
      let promedioAdaptabilidad = this.arrAdaptabilidad.reduce(reducer) / 3;
      this.promediosDom[1] = promedioAdaptabilidad.toFixed(2);
      let promedioConocimiento = this.arrConocimiento.reduce(reducer) / 3;
      this.promediosDom[2] = promedioConocimiento.toFixed(2);
      let promedioAgilidad = this.arrAgilidad.reduce(reducer) / 3;
      this.promediosDom[3] = promedioAgilidad.toFixed(2);
      let promedioDigital = this.arrDigital.reduce(reducer) / 3;
      this.promediosDom[4] = promedioDigital.toFixed(2);

      let radarFlexibilidad = (promedioFlexibilidad / 4) * 5;
      this.radarDom[0] = radarFlexibilidad.toFixed(2);
      let radarAdaptabilidad = (promedioAdaptabilidad / 4) * 5;
      this.radarDom[1] = radarAdaptabilidad.toFixed(2);
      let radarConocimiento = (promedioConocimiento / 4) * 5;
      this.radarDom[2] = radarConocimiento.toFixed(2);
      let radarAgilidad = (promedioAgilidad / 4) * 5;
      this.radarDom[3] = radarAgilidad.toFixed(2);
      let radarDigital = (promedioDigital / 4) * 5;
      this.radarDom[4] = radarDigital.toFixed(2);

      let radarProcesos = (this.arrAdaptabilidad[0] / 4) * 5;
      this.radarDim[0] = radarProcesos.toFixed(2);
      let radarOrganigrama = (this.arrAdaptabilidad[1] / 4) * 5;
      this.radarDim[1] = radarOrganigrama.toFixed(2);
      let radarProductivo = (this.arrAdaptabilidad[2] / 4) * 5;
      this.radarDim[2] = radarProductivo.toFixed(2);
      let radarLiderzago = (this.arrFlexibilidad[0] / 4) * 5;
      this.radarDim[3] = radarLiderzago.toFixed(2);
      let radarGerencia = (this.arrFlexibilidad[0] / 4) * 5;
      this.radarDim[4] = radarGerencia.toFixed(2);
      let radarExperimentacion = (this.arrFlexibilidad[0] / 4) * 5;
      this.radarDim[5] = radarExperimentacion.toFixed(2);
      let radarTendencias = (this.arrConocimiento[0] / 4) * 5;
      this.radarDim[6] = radarTendencias.toFixed(2);
      let radarCompetencia = (this.arrConocimiento[1] / 4) * 5;
      this.radarDim[7] = radarCompetencia.toFixed(2);
      let radarClientes = (this.arrConocimiento[2] / 4) * 5;
      this.radarDim[8] = radarClientes.toFixed(2);
      let radarDeterminacion = (this.arrAgilidad[0] / 4) * 5;
      this.radarDim[9] = radarDeterminacion.toFixed(2);
      let radarAsignacion = (this.arrAgilidad[1] / 4) * 5;
      this.radarDim[10] = radarAsignacion.toFixed(2);
      let radarEjecucion = (this.arrAgilidad[2] / 4) * 5;
      this.radarDim[11] = radarEjecucion.toFixed(2);
      let radarEstrategia = (this.arrDigital[0] / 4) * 5;
      this.radarDim[12] = radarEstrategia.toFixed(2);
      let radarCultura = (this.arrDigital[1] / 4) * 5;
      this.radarDim[13] = radarCultura.toFixed(2);
      let radarTalentos = (this.arrDigital[2] / 4) * 5;
      this.radarDim[14] = radarTalentos.toFixed(2);
      //respuestas
      let respuestaLiderazgo = this.respuestasDim[0];
      let respuestaGerencia = this.respuestasDim[1];
      let respuestaExperimentacion = this.respuestasDim[2];
      let respuestaPInternos = this.respuestasDim[3];
      let respuestaOrganigrama = this.respuestasDim[4];
      let respuestaPProductivo = this.respuestasDim[5];
      let respuestaTendencias = this.respuestasDim[6];
      let respuestaCompetencia = this.respuestasDim[7];
      let respuestaClientes = this.respuestasDim[8];
      let respuestaDeterminacion = this.respuestasDim[9];
      let respuestaAsignacion = this.respuestasDim[10];
      let respuestaEjecucion = this.respuestasDim[11];
      let respuestaEstrategia = this.respuestasDim[12];
      let respuestaCultura = this.respuestasDim[13];
      let respuestaTalentos = this.respuestasDim[14];
      //Subida Resultados Base de datos
      this.db.updateResultados(
        {
          Flexibilidad: this.arrFlexibilidad,
          Adaptabilidad: this.arrAdaptabilidad,
          Conocimiento: this.arrConocimiento,
          Agilidad: this.arrAgilidad,
          Digital: this.arrDigital,
          MtzGeneralDim: this.promediosDim,
        },
        {
          PromedioFlexiblidad: this.promediosDom[0],
          PromedioAdaptabilidad: this.promediosDom[1],
          PromedioConocimiento: this.promediosDom[2],
          PromedioAgilidad: this.promediosDom[3],
          PromedioDigital: this.promediosDom[4],
          MtzGeneralDom: this.promediosDom,
        },
        {
          radarProcesos: this.radarDim[0],
          radarOrganigrama: this.radarDim[1],
          radarProductivo: this.radarDim[2],
          radarLiderzago: this.radarDim[3],
          radarGerencia: this.radarDim[4],
          radarExperimentacion: this.radarDim[5],
          radarTendencias: this.radarDim[6],
          radarCompetencia: this.radarDim[7],
          radarClientes: this.radarDim[8],
          radarDeterminacion: this.radarDim[9],
          radarAsignacion: this.radarDim[10],
          radarEjecucion: this.radarDim[11],
          radarEstrategia: this.radarDim[12],
          radarCultura: this.radarDim[13],
          radarTalentos: this.radarDim[14],
          MtzGeneralRadarDim: this.radarDim,
        },
        {
          radarFlexiblidad: this.radarDom[0],
          radarAdaptabilidad: this.radarDom[1],
          radarConocimiento: this.radarDom[2],
          radarAgilidad: this.radarDom[3],
          radarDigital: this.radarDom[4],
          MtzGeneralRadarDom: this.radarDom,
        },
        {
          respuestasLiderazgo: { respuestaLiderazgo },
          respuestasGerencia: { respuestaGerencia },
          respuestasExperimentacion: { respuestaExperimentacion },
          respuestasPInternos: { respuestaPInternos },
          respuestasOrganigrama: { respuestaOrganigrama },
          respuestasPProductivo: { respuestaPProductivo },
          respuestasTendencias: { respuestaTendencias },
          respuestasCompetencia: { respuestaCompetencia },
          respuestasClientes: { respuestaClientes },
          respuestasDeterminacion: { respuestaDeterminacion },
          respuestasAsignacion: { respuestaAsignacion },
          respuestasEjecucion: { respuestaEjecucion },
          respuestasEstrategia: { respuestaEstrategia },
          respuestasCultura: { respuestaCultura },
          respuestasTalentos: { respuestaTalentos },
        }
      );
    }
  }

  pintarModelo() {
    return this.db
      .getUserByCedula(Number(localStorage.getItem('Cedula')))
      .pipe(first())
      .toPromise()
      .then((data: any) => {
        sessionStorage.setItem('id', data[0]?.id);
        const nombre: HTMLElement = document.getElementById('Nombre');
        if (nombre) {
          nombre.textContent = data[0]?.Nombres + ' ' + data[0]?.Apellidos;
        }

        this.mtzRadarDimension = data[0]?.RadarDimension?.MtzGeneralRadarDim;
        this.mtzRadarDominio = data[0]?.RadarDominio?.MtzGeneralRadarDom;
        this.liderazgo = data[0]?.PromedioDimension?.Flexibilidad[0];
        this.gerencia = data[0]?.PromedioDimension?.Flexibilidad[1];
        this.experimentacion = data[0]?.PromedioDimension?.Flexibilidad[2];

        this.internos = data[0]?.PromedioDimension?.Adaptabilidad[0];
        this.organigrama = data[0]?.PromedioDimension?.Adaptabilidad[1];
        this.productivo = data[0]?.PromedioDimension?.Adaptabilidad[2];

        this.tendencia = data[0]?.PromedioDimension?.Conocimiento[0];
        this.competencia = data[0]?.PromedioDimension?.Conocimiento[1];
        this.clientes = data[0]?.PromedioDimension?.Conocimiento[2];

        this.determinacion = data[0]?.PromedioDimension?.Agilidad[0];
        this.asignacion = data[0]?.PromedioDimension?.Agilidad[1];
        this.ejecucion = data[0]?.PromedioDimension?.Agilidad[2];

        this.estrategias = data[0]?.PromedioDimension?.Digital[0];
        this.cultura = data[0]?.PromedioDimension?.Digital[1];
        this.talentos = data[0]?.PromedioDimension?.Digital[2];

        if (this.cultura > 0 && this.cultura <= 2.6) {
          this.imgcultura1 = `../assets/img/pruebas/modelos/1/1.png`;
          this.imgcultura2 = `../assets/img/pruebas/modelos/1/2.png`;
          this.imgcultura3 = `../assets/img/pruebas/modelos/1/3.png`;
        } else if (this.cultura > 2.6 && this.cultura <= 3.4) {
          this.imgcultura1 = `../assets/img/pruebas/modelos/2/1.png`;
          this.imgcultura2 = `../assets/img/pruebas/modelos/2/2.png`;
          this.imgcultura3 = `../assets/img/pruebas/modelos/2/3.png`;
        } else if (this.cultura > 3.4 && this.cultura <= 4) {
          this.imgcultura1 = `../assets/img/pruebas/modelos/3/1.png`;
          this.imgcultura2 = `../assets/img/pruebas/modelos/3/2.png`;
          this.imgcultura3 = `../assets/img/pruebas/modelos/3/3.png`;
        }
        if (this.liderazgo > 0 && this.liderazgo <= 2.6) {
          this.imgliderazgo = `../assets/img/pruebas/modelos/1/4.png`;
        } else if (this.liderazgo > 2.6 && this.liderazgo <= 3.4) {
          this.imgliderazgo = `../assets/img/pruebas/modelos/2/4.png`;
        } else if (this.liderazgo > 3.4 && this.liderazgo <= 4) {
          this.imgliderazgo = `../assets/img/pruebas/modelos/3/4.png`;
        }
        if (this.estrategias > 0 && this.estrategias <= 2.6) {
          this.imgestretegia = `../assets/img/pruebas/modelos/1/5.png`;
        } else if (this.estrategias > 2.6 && this.estrategias <= 3.4) {
          this.imgestretegia = `../assets/img/pruebas/modelos/2/5.png`;
        } else if (this.estrategias > 3.4 && this.estrategias <= 4) {
          this.imgestretegia = `../assets/img/pruebas/modelos/3/5.png`;
        }
        if (this.asignacion > 0 && this.asignacion <= 2.6) {
          this.imgasignacion = `../assets/img/pruebas/modelos/1/6.png`;
        } else if (this.asignacion > 2.6 && this.asignacion <= 3.4) {
          this.imgasignacion = `../assets/img/pruebas/modelos/2/6.png`;
        } else if (this.asignacion > 3.4 && this.asignacion <= 4) {
          this.imgasignacion = `../assets/img/pruebas/modelos/3/6.png`;
        }
        if (this.gerencia > 0 && this.gerencia <= 2.6) {
          this.imggerencia = `../assets/img/pruebas/modelos/1/7.png`;
        } else if (this.gerencia > 2.6 && this.gerencia <= 3.4) {
          this.imggerencia = `../assets/img/pruebas/modelos/2/7.png`;
        } else if (this.gerencia > 3.4 && this.gerencia <= 4) {
          this.imggerencia = `../assets/img/pruebas/modelos/3/7.png`;
        }
        if (this.clientes > 0 && this.clientes <= 2.6) {
          this.imgclientes = `../assets/img/pruebas/modelos/1/8.png`;
        } else if (this.clientes > 2.6 && this.clientes <= 3.4) {
          this.imgclientes = `../assets/img/pruebas/modelos/2/8.png`;
        } else if (this.clientes > 3.4 && this.clientes <= 4) {
          this.imgclientes = `../assets/img/pruebas/modelos/3/8.png`;
        }
        if (this.organigrama > 0 && this.organigrama <= 2.6) {
          this.imgorganigrama = `../assets/img/pruebas/modelos/1/9.png`;
        } else if (this.organigrama > 2.6 && this.organigrama <= 3.4) {
          this.imgorganigrama = `../assets/img/pruebas/modelos/2/9.png`;
        } else if (this.organigrama > 3.4 && this.organigrama <= 4) {
          this.imgorganigrama = `../assets/img/pruebas/modelos/3/9.png`;
        }
        if (this.talentos > 0 && this.talentos <= 2.6) {
          this.imgtalentos = `../assets/img/pruebas/modelos/1/10.png`;
        } else if (this.talentos > 2.6 && this.talentos <= 3.4) {
          this.imgtalentos = `../assets/img/pruebas/modelos/2/10.png`;
        } else if (this.talentos > 3.4 && this.talentos <= 4) {
          this.imgtalentos = `../assets/img/pruebas/modelos/3/10.png`;
        }
        if (this.productivo > 0 && this.productivo <= 2.6) {
          this.imgproductivo = `../assets/img/pruebas/modelos/1/13.png`;
        } else if (this.productivo > 2.6 && this.productivo <= 3.4) {
          this.imgproductivo = `../assets/img/pruebas/modelos/2/13.png`;
        } else if (this.productivo > 3.4 && this.productivo <= 4) {
          this.imgproductivo = `../assets/img/pruebas/modelos/3/13.png`;
        }
        if (this.experimentacion > 0 && this.experimentacion <= 2.6) {
          this.imgexperimentacion = `../assets/img/pruebas/modelos/1/14.png`;
        } else if (this.experimentacion > 2.6 && this.experimentacion <= 3.4) {
          this.imgexperimentacion = `../assets/img/pruebas/modelos/2/14.png`;
        } else if (this.experimentacion > 3.4 && this.experimentacion <= 4) {
          this.imgexperimentacion = `../assets/img/pruebas/modelos/3/14.png`;
        }
        if (this.internos > 0 && this.internos <= 2.6) {
          this.imginternos = `../assets/img/pruebas/modelos/1/15.png`;
        } else if (this.internos > 2.6 && this.internos <= 3.4) {
          this.imginternos = `../assets/img/pruebas/modelos/2/15.png`;
        } else if (this.internos > 3.4 && this.internos <= 4) {
          this.imginternos = `../assets/img/pruebas/modelos/3/15.png`;
        }
        if (this.ejecucion > 0 && this.ejecucion <= 2.6) {
          this.imgejecucion = `../assets/img/pruebas/modelos/1/16.png`;
        } else if (this.ejecucion > 2.6 && this.ejecucion <= 3.4) {
          this.imgejecucion = `../assets/img/pruebas/modelos/2/16.png`;
        } else if (this.ejecucion > 3.4 && this.ejecucion <= 4) {
          this.imgejecucion = `../assets/img/pruebas/modelos/3/16.png`;
        }
        if (this.competencia > 0 && this.competencia <= 2.6) {
          this.imgcompetencia = `../assets/img/pruebas/modelos/1/17.png`;
        } else if (this.competencia > 2.6 && this.competencia <= 3.4) {
          this.imgcompetencia = `../assets/img/pruebas/modelos/2/17.png`;
        } else if (this.competencia > 3.4 && this.competencia <= 4) {
          this.imgcompetencia = `../assets/img/pruebas/modelos/3/17.png`;
        }
        if (this.tendencia > 0 && this.tendencia <= 2.6) {
          this.imgtendencia = `../assets/img/pruebas/modelos/1/18.png`;
        } else if (this.tendencia > 2.6 && this.tendencia <= 3.4) {
          this.imgtendencia = `../assets/img/pruebas/modelos/2/18.png`;
        } else if (this.tendencia > 3.4 && this.tendencia <= 4) {
          this.imgtendencia = `../assets/img/pruebas/modelos/3/18.png`;
        }
        if (this.determinacion > 0 && this.determinacion <= 2.6) {
          this.imgdeterminacion1 = `../assets/img/pruebas/modelos/1/19.png`;
          this.imgdeterminacion2 = `../assets/img/pruebas/modelos/1/20.png`;
          this.imgdeterminacion3 = `../assets/img/pruebas/modelos/1/21.png`;
        } else if (this.determinacion > 2.6 && this.determinacion <= 3.4) {
          this.imgdeterminacion1 = `../assets/img/pruebas/modelos/2/19.png`;
          this.imgdeterminacion2 = `../assets/img/pruebas/modelos/2/20.png`;
          this.imgdeterminacion3 = `../assets/img/pruebas/modelos/2/21.png`;
        } else if (this.determinacion > 3.4 && this.determinacion <= 4) {
          this.imgdeterminacion1 = `../assets/img/pruebas/modelos/3/19.png`;
          this.imgdeterminacion2 = `../assets/img/pruebas/modelos/3/20.png`;
          this.imgdeterminacion3 = `../assets/img/pruebas/modelos/3/21.png`;
        }
      });
  }

  navegarA(ruta) {
    this.router.navigate([ruta]);
  }

  navegarPrueba(ruta, cc, datos) {
    return this.db.getUserByCedula(cc)
    .pipe(first())
    .toPromise()
    .then((data: any) => {
      if (data.length != 0) {
        alert('Ya te encuentras en nuestra base de datos');
        this.router.navigate(['/home']);
      } else {
        this.db.updateDatos(datos).then(() => {
          this.router.navigate([ruta]);
        });
      }
    });
  }

  navegarResultados(cc: number, ruta: string) {
    localStorage.setItem('Cedula', cc.toString());
    return this.db
      .getUserByCedula(cc)
      .pipe(first())
      .toPromise()
      .then((data: any) => {

        if (data && data.length > 0) {
          const user = data[0];

          sessionStorage.setItem('id', user?.id);
          this.router.navigate([ruta]);
        } else {
          console.warn('❌ Usuario no encontrado en la base de datos');
          alert('No te encuentras en nuestra base de datos, realiza tu prueba');
          this.router.navigate(['/descripcion']);
        }
      })
      .catch((err) => {
        console.error('🚨 Error al consultar Firestore:', err);
      });
  }

  navegarResultadosDespuesPrueba(ruta, cc) {
    return this.db
      .getUserByCedula(cc)
      .pipe(first())
      .toPromise()
      .then((data: any) => {
        sessionStorage.setItem('id', data[0]?.id);
        if (data.length != 0) {
          this.router.navigate([ruta]);
        }
      });
  }

  async imgModelo() {
    var imgModelo = document.getElementById('imgModelo');
    await html2canvas(imgModelo, {
      backgroundColor: null,
    }).then((canvas) => {
      this.imagenModelo = canvas.toDataURL('image/png');
    });
  }

  async pdf() {
    //debugger
    var contenedor = document.getElementById('pdfContent');
    let h = contenedor.offsetHeight;
    let w = contenedor.offsetWidth;
    if (
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)
    ) {
      var doc = new jsPDF('p', 'pt', [h, w]);
      this.widthImage = w;
      this.heigthImage = h + 700;
    } else {
      var doc = new jsPDF('l', 'pt', [h, w]);
      this.widthImage = w;
      this.heigthImage = h + 200;
    }

    await domToImage
      .toPng(contenedor, {
        //heigth: h,
        //width: w,
        /*scrollX: 0,
      scrollY: 0*/

        width: this.widthImage,
        height: this.heigthImage,
      })
      .then((canvas) => {
        var img = new Image();
        img.src = canvas;
        //document.body.appendChild(canvas);
        doc.addImage(img, 'PNG', 1, 0, w, h);
        doc.save(`PruebaCSE.pdf`);
       return null;
      })
      .catch((res) => {
        return res;
      });
  }
}
